import http from '@homeservices/api-kit/axios';

export default {
  namespaced: true,
  state: {
    inbox: [],
    count: 0,
    total: 0,
    unreadMessages: [],

  },
  getters: {
    hasUnreadMessages (state) {
      return state.unreadMessages.length > 0;
    },
    unreadMessages (state) {
      return state.unreadMessages;
    },
    getInbox (state) {
      return state.inbox;
    },
    getCount (state) {
      return state.count;
    },
    getTotal (state) {
      return state.total;
    },
  },
  actions: {
    async fetchInbox ({ commit }, { params = {}, reason }) {
      const { data } = await http.get('/platform/workorder/r/workorder/prorders/messages/inbox/v1', {
        params: {
          size: '20',
          ...params,
        },
      }
      );
      if (reason === 'list') {
        commit('setInbox', data.results.filter(message => message.order_hash !== null));
        commit('setTotal', data.total);
        commit('setCount', data.count);
      } else {
        commit('clearUnreadMessages');
        commit('setUnreadMessages', data.results.filter(message => message.sender_type === 'consumer' && message.time_read === null && message.order_hash !== null));
      }
    },
    removeFromUnread ({ state, commit }, { message_id, order_hash }) {
      const newList = state.unreadMessages.filter(
        message => message.message_id !== message_id && message.order_hash !== order_hash);
      commit('setUnreadMessages', newList);
    },
    async updateInbox ({ commit, dispatch }) {
      commit('clearInbox');
      dispatch('fetchInbox', { reason: 'list' });
    },
    clearInbox ({ commit }) {
      commit('clearInbox');
    },
  },
  mutations: {
    setInbox (state, data) {
      const list = [...state.inbox, ...data];
      state.inbox = list;
    },
    setCount (state, data) {
      state.count = data;
    },
    setTotal (state, data) {
      state.total = data;
    },
    setUnreadMessages (state, data) {
      state.unreadMessages = data;
    },
    clearUnreadMessages (state) {
      state.unreadMessages = [];
    },
    clearInbox (state) {
      state.inbox = [];
    },
  },
};
